import { metroCompanyId } from "../env";
import { UserRole } from "../interfaces/intefaces";

interface ICompany{
    id: number;
}
interface IUser {
    id: number;
    role: UserRole;
    company: ICompany
}

export function isMetroUser(user: IUser){
    if(!user || !user.company) return false;

    return user.company.id === metroCompanyId; 
}

export function isAdmin(user: IUser){
    if(!user || !user.role) return false;

    return user.role == UserRole.ADMIN;
}

export function isOperator(user: IUser){
    if(!user || !user.role) return false;

    return user.role == UserRole.OPERATOR;
}

export function isUserCompany(user: IUser, company: ICompany) {
    if (!user || !user.company) return false;

    return user.company.id === company.id;
}